import { formatDate, getCurrentUser } from '../utils/common.util';
import { PrintView } from './PrintView/print-view.component';

export default function PrintOutHead({
  title = '',
  headings = [],
  noPrintView = false,
}) {
  const { firstName, lastName } = getCurrentUser();

  const statsItems = [
    ...headings,
    { label: 'Date Generated', value: formatDate(new Date()) },
    { label: 'Generated By', value: firstName + ' ' + lastName },
  ];

  const content = (
    <div className="print-view mb-40">
      <StatsTitle title={title} />
      <hr className="grey-hr mt-210 mb-10" />
      <StatsBar statsItems={statsItems} />
    </div>
  );

  return <>{noPrintView ? content : <PrintView>{content}</PrintView>}</>;
}

export function StatsTitle({ title }) {
  const { school } = getCurrentUser();

  return (
    <div className="mt-15 bx--col--auto mb-20">
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          style={{ height: '80px', width: '80px', borderRadius: '50%' }}
          src={school.logoUrl}
          alt={school.name}
        />
      </div>
      <h3 className="h-20 text-primary text-center">{school.name}</h3>
      <p className="text-13 text-grey-dark text-center">{school.location}</p>

      <p className="text-center text-16 text-primary font-bold mt-20 text-uppercase">
        {title}
      </p>
    </div>
  );
}

export function StatsBar({ statsItems, ...props }) {
  return (
    <div
      {...props}
      className="mt-15"
      style={{
        display: 'flex',
        gap: '20px',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      {statsItems.map((item) => (
        <div key={item.label}>
          <p className="text-14 text-grey-light">{item.label}</p>
          <h3 className="h-14">{item.value}</h3>
        </div>
      ))}
    </div>
  );
}
